import { create } from 'zustand';
import { ShiftTypePreset } from '@libs/models/shiftTemplates/shiftTypes';
import {
  createSingleShiftTemplatePreset,
  deleteSingleShiftTypePreset,
  SingleShiftTemplatePresetCreateData,
  SingleShiftTemplatePresetEditData,
  updateSingleShiftTypePreset,
} from '@libs/api/shiftTypes';

type InitialState = {
  open: boolean;
  loading: boolean;
  currentEntityId: string;
  entity: ShiftTypePreset | null;

  create: (data: SingleShiftTemplatePresetCreateData) => Promise<void>;
  update: (data: SingleShiftTemplatePresetEditData) => Promise<void>;
  delete: (id: string) => Promise<void>;
  openDrawer: (id?: string, entity?: ShiftTypePreset) => void;
  closeDrawer: () => void;
};

export const useShiftTypePresetDrawerStore = create<InitialState>()((set) => ({
  open: false,
  loading: false,
  currentEntityId: '',
  entity: null,

  create: async (data: SingleShiftTemplatePresetCreateData) => {
    set({ loading: true });
    try {
      await createSingleShiftTemplatePreset(data);
    } catch (error) {
      console.error('Error creating shift type preset:', error);
      throw error;
    } finally {
      set({ loading: false });
    }
  },
  update: async (data: SingleShiftTemplatePresetEditData) => {
    set({ loading: true });
    try {
      await updateSingleShiftTypePreset(data);
    } catch (error) {
      console.error('Error updating shift type preset:', error);
      throw error;
    } finally {
      set({ loading: false });
    }
  },
  delete: async (id: string) => {
    set({ loading: true });
    try {
      await deleteSingleShiftTypePreset(id);
    } catch (error) {
      console.error('Error deleting shift type preset:', error);
      throw error;
    } finally {
      set({ loading: false });
    }
  },
  openDrawer: (id = undefined, entity = undefined) => {
    set({ open: true, currentEntityId: id || '', entity: entity || null });
  },
  closeDrawer: () => {
    set({ open: false, currentEntityId: '', entity: null });
  },
}));
